import { connect } from "react-redux";
import AllSupervisorList from "./AllSupervisorList";
import { bindActionCreators } from "redux";
import { getSupervisorListData } from "services/redux/Valet/Supervisor/action";
const mapStateToProps = (state) => ({
    supervisorListData: state.CreateSupervisor.supervisorListData
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getSupervisorListData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AllSupervisorList);
